import { api } from 'shared';
import { z } from 'zod';

export const CrewMembersResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            name: z.string(),
            jobTitle: z.string().optional().nullable(),
            description: z.any().optional().nullable(),
            position: z.number().optional().nullable(),
            image: z.object({
                url: z.string(),
            }).optional().nullable(),
        }),
    ).optional().nullable(),
});
export const fetchCrewMembers = async () => (
    api.get<z.infer<typeof CrewMembersResponseSchema>>(
        '/crew-members',
        {
            populate: {
                image: {
                    fields: 'url',
                },
            },
        },
        CrewMembersResponseSchema,
    )
);
